import '../questions/components/question';
import '../questions/components/question_belt';
import '../questions/components/question_belt_logged_out';
import '../questions/components/question_counter';
import './components/insights';
import './components/next_question';
import './components/plans_highlights';
import './components/question_suggestion';
import './components/related_exams';
import './components/related_exams_v2';
import './components/related_questions';
import './components/related_questions_v2';
import './components/search';
import './index.scss';
import 'components/banner_approval_cta';
import 'components/contextual_course_banner';
import 'components/menu_bar_float';
import 'components/summary_suggestions';
import 'styles/components/_alerts.scss';
import zaraz from 'utils/trackers/zaraz';

const renderQuestionLabel = $questionItem => {
  const status = $questionItem.data('status');

  if (!['nullified', 'outdated'].includes(status)) {
    return;
  }

  const modifier = status === 'nullified' ? 'nullified' : 'outdated';
  const icon = status === 'nullified' ? 'info-circle' : 'exclamation-circle';

  const caption =
    status === 'nullified' ? 'Questão anulada' : 'Questão desatualizada';

  const html = `
    <label class="q-question-label q-question-label--${modifier}">
      <div class="q-caption">
        <i class="q-icon q-icon-${icon}"></i>
        <span>${caption}</span>
      </div>
    </label>`;

  $('.js-question-label', $questionItem).html(html);
};

(function ($) {
  'use strict';

  const $component = $('.q-question-belt');

  $('.q-tab-close-btn', $component).on('click', () => {
    $('.nav-tabs .active', $component).removeClass('active');
    $('.nav-tabs [data-toggle="tab"]', $component).attr('aria-expanded', false);
    $('.tab-pane.active', $component).removeClass('active');
  });

  const $container = $('[data-event]');
  const eventData = $container.data('event') || {};

  const isSendEvent = eventData?.zaraz_send_event && eventData?.event_props;

  if ($container && isSendEvent) {
    zaraz.set('show_experiment', 'true', { scope: 'persist' });
    zaraz.track(eventData.zaraz_event, eventData.event_props);
  }

  renderQuestionLabel($('.js-question-item'));
})(jQuery);
